import React, {useState} from "react";
import {Box, FormControlLabel, Icon, Switch, Tooltip} from "@mui/material";
import {GraphQlDataGrid, nestedValueGetter} from "../../../../components/common/grid/GraphQlDataGrid";
import {graphQLServices} from "../../../../services/GraphQLServices";
import {GridFilterItem} from "@mui/x-data-grid/models/gridFilterItem";
import gqlGetPolicyLookup from "../graphql/queries/gqlGetPolicyLookup";
import {DensitySmall, HourglassTop, NotInterested} from "@mui/icons-material";
import {translateFunction} from "../../../../localization/TranslationService";
const translate = translateFunction("SureBaseDocuments");

interface IPolicyLookup {
	onRowClick?: (row: any) => void;
	defaultFilter?: GridFilterItem[];
	autoSelectSingleRecord?: boolean;
}

const defaultFilter = [
	{
		field: "policy.nr",
		operator: "equals",
	},
	{
		field: "policy.kenteken",
		operator: "equals",
	},

	{
		field: "customer.id",
		operator: "startsWith",
	},
	{
		field: "customer.naam",
		operator: "startsWith",
	},
	{
		field: "customer.plaats",
		operator: "startsWith",
	},
	{
		field: "customer.postcode",
		operator: "startsWith",
	},
];

export const PolicyLookup: React.FC<IPolicyLookup> = (props) => {
	const [activeOnly, setActiveOnly] = useState<boolean>(false);
	const filter = defaultFilter.filter((it) => props.defaultFilter &&  (props.defaultFilter.filter((x) => x.field === it.field  ).length === 0));

	return (
		<Box>
			<FormControlLabel control={
				<Switch name="Inactief" checked={!activeOnly} onChange={() => setActiveOnly(!activeOnly)} />
			} label="Inclusief inactief"/>
			<GraphQlDataGrid
				enableHeaderFilter
				hideExportButton
				client={graphQLServices.documentsClient}
				query={
					gqlGetPolicyLookup
				}
				defaultSortModel={[
					{
						field: "policy.id",
						sort: "asc"
					}
				]}
				defaultFilterModel={{
					items: [...filter??[],...props.defaultFilter??[]]
				}}

				columns={[
					{
						field: "active",
						headerName: translate("Info"),

						valueGetter: nestedValueGetter,
						width: 80,
						sortable: false,
						filterable: false,
						type: "boolean",
						renderCell: (params) => {
							return (
								<>
									{!params.row.active && <Tooltip title={translate("Inactive")}><NotInterested/></Tooltip>}
									{params.row.active && <Tooltip title={translate("Inactive")}><Icon/></Tooltip>}
									{params.row.wait && <Tooltip title={translate("Wait")}><HourglassTop /></Tooltip>}
									{!params.row.wait && <Tooltip title={translate("Wait")}><Icon /></Tooltip>}
									{params.row.policy.swPakket && <Tooltip title={translate("Package")}><DensitySmall/></Tooltip>}
									{!params.row.policy.swPakket && <Tooltip title={translate("Package")}><Icon/></Tooltip>}
								</>
							);
						},
					},
					{
						field: "policy.id",
						headerName: "Id",
						valueGetter: nestedValueGetter,
						width: 180,
						sortable: true,
					},
					{
						field: "policy.nr",
						headerName: "Nr",
						valueGetter: nestedValueGetter,
						width: 200,
						sortable: true,
					},
					{
						field: "policy.kenteken",
						headerName: "Kenteken",
						valueGetter: nestedValueGetter,
						filterIgnoreCase: true,
						width: 150,
						sortable: true,
					},

					{
						field: "policy.relnr",
						headerName: "Relatienr",
						valueGetter: nestedValueGetter,
						filterIgnoreCase: true,
						width: 150,
						sortable: true,
					},
					{
						field: "customer.naam",
						headerName: "Naam",
						valueGetter: nestedValueGetter,
						filterIgnoreCase: true,
						width: 300,
						sortable: false,
						filterable: false
					},
					{
						field: "brancheSpec.omschrijving",
						headerName: "Branche",
						valueGetter: nestedValueGetter,
						filterIgnoreCase: true,
						width: 300,
						sortable: false,
						filterable: false
					}
				]}
				graphFunction={
					"policiesLookup"
				}
				queryVariables={{"activeOnly": activeOnly, "includeWaitPolicies": !activeOnly}}
				rows={[]}
				getRowId={(item:any)=> item.policy.id}
				initialPageSize={10}
				rowsPerPageOptions={[5, 10, 20]}
				autoHeight={true}
				//disableColumnFilter
				//disableColumnMenu
				onRowClick={(params) => props.onRowClick && props.onRowClick(params.row)}
				autoSelectSingleRecord={props.autoSelectSingleRecord}
				onAutoSelect={(row) => props.onRowClick && props.onRowClick(row)}
			/>

		</Box>
	);
};
